exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.delay-view-wrapper{overflow-y:hidden}.delay-view-wrapper__heading{border-bottom:1px solid #979797}.delay-view-wrapper__heading h4{margin:16px 0 8px 24px;font-family:Open Sans,sans-serif;line-height:16px;color:#2c2c2c;font-size:18px;font-weight:400}.delay-view-wrapper__content{position:relative;height:calc(100% - 98px);min-height:350px}#view-wrapper{overflow-y:hidden}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/mobileWrappers/DelayViewWrapper/DelayViewWrapper.scss
// module id = 1863
// module chunks = 0